// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\DTO.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { TaskDataDTO } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/TaskDataDTO';
import { GlobalParamDTO } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/GlobalParamDTO';
/**
 * 回调实体 DTO类
 * 回调实体
 */
export class PublishCallBackDataDTO {
  /** 事件名称 : 事件名称 */
  private _event: string;

  /** 设置：事件名称 */
  public get event() {
    return this._event;
  }

  /** 获取：事件名称 */
  public set event(value: string) {
    this._event = value;
  }

  /** 执行动作 : 执行动作 */
  private _action: string;

  /** 设置：执行动作 */
  public get action() {
    return this._action;
  }

  /** 获取：执行动作 */
  public set action(value: string) {
    this._action = value;
  }

  /** 任务明细 : 任务明细 */
  private _task: TaskDataDTO;

  /** 设置：任务明细 */
  public get task() {
    return this._task;
  }

  /** 获取：任务明细 */
  public set task(value: TaskDataDTO) {
    this._task = value;
  }

  /** 全局参数 : 全局参数 */
  private _globalParams: Array<GlobalParamDTO>;

  /** 设置：全局参数 */
  public get globalParams() {
    return this._globalParams;
  }

  /** 获取：全局参数 */
  public set globalParams(value: Array<GlobalParamDTO>) {
    this._globalParams = value;
  }

  constructor() {
    this._event = '';
    this._action = '';
    this._task = new TaskDataDTO();
    this._globalParams = new Array<GlobalParamDTO>();
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  protected Deserialize(json: any): void {
    this.event = json.Event;
    this.action = json.Action;
    this.task = json.Task as TaskDataDTO;
    json.GlobalParams.forEach((element: any) => this.globalParams.push(GlobalParamDTO.Create(element)));
  }

  protected Serialize(json: any): void {
    json.Event = this.event;
    json.Action = this.action;
    json.Task = this.task;
    this.globalParams.forEach((element) => json.GlobalParams.push(element.toJson()));
  }

  static Create(json: any): PublishCallBackDataDTO {
    const publishCallBackDataDTO = new PublishCallBackDataDTO();
    publishCallBackDataDTO.Deserialize(json);
    return publishCallBackDataDTO;
  }
}
